export const SUBMISSIONS_OVERVIEW_SKELETON_HEIGHT = 160;
